import type { QueryClient } from '@tanstack/react-query'

interface Invalidation {
  module?: unknown
  entity?: unknown
  actorMemberId?: unknown
}

/** Eine zentrale Zuordnung vom Domain-Modul auf React-Query-Caches. */
export function verbindeStream(qc: QueryClient, memberId: string): () => void {
  const stream = new EventSource('/api/stream', { withCredentials: true })
  const invalidieren = (roh: Event) => {
    if (!(roh instanceof MessageEvent) || typeof roh.data !== 'string') return
    try {
      const event = JSON.parse(roh.data) as Invalidation
      if (event.actorMemberId === memberId || typeof event.module !== 'string') return
      void qc.invalidateQueries({ queryKey: [event.module] })
      void qc.invalidateQueries({ queryKey: ['activity'] })
      void qc.invalidateQueries({ queryKey: ['dashboard'] })
      // ⚠️ Der Posteingang haengt am SELBEN Strom - kein zweiter Poll. Der
      // Filter oben (eigene Handlung wird uebersprungen) stoert dabei nicht:
      // eine Benachrichtigung geht nie an den Ausloeser.
      void qc.invalidateQueries({ queryKey: ['notifications'] })
    } catch {
      // Ein kaputtes Ereignis darf die automatisch reconnectende Verbindung
      // nicht schließen. Der nächste reguläre Refetch bleibt die Wahrheit.
    }
  }
  stream.addEventListener('invalidate', invalidieren)
  return () => {
    stream.removeEventListener('invalidate', invalidieren)
    stream.close()
  }
}
